import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { formatDateTime } from 'common/usual'
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CardActions,
  TablePagination,
} from '@material-ui/core'
import EditBtn from 'components/EditBtn'

const MealIngredientPreparationTable = props => {
  const { data, page, onPageChange } = props

  return (
    <Card>
      <CardContent className={'table-content'}>
        <PerfectScrollbar>
          <div className={'inner'}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Active</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {data.rows && data.rows.map(preparation => (
                  <TableRow className={'table-row'} key={preparation.id} hover>
                    <TableCell>{preparation.id}</TableCell>
                    <TableCell>{preparation.title}</TableCell>
                    <TableCell>{preparation.active ? 'TRUE' : 'FALSE'}</TableCell>
                    <TableCell>{formatDateTime(preparation.createdAt)}</TableCell>
                    <TableCell>
                      <EditBtn history={props.history} path={`/meal-ingredient/preparation/edit/${preparation.id}`} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={'flex-right'}>
        <TablePagination
          component="div"
          count={data.count || 0}
          onChangePage={onPageChange}
          page={page-1}
          rowsPerPage={10}
          rowsPerPageOptions={[10]}
        />
      </CardActions>
    </Card>
  )
}

export default MealIngredientPreparationTable